import React from 'react';
import PropTypes from 'prop-types';
import ToolSelectComponent from '../tool-select-base/tool-select-base.jsx';
import messages from '../../lib/messages.js';
import fillIcon from './fill.svg';

const FillModeComponent = (props) => (
  <ToolSelectComponent
    imgDescriptor={messages.fill}
    imgSrc={fillIcon}
    isSelected={props.isSelected}
    onMouseDown={props.onMouseDown}
    keybinding="F"
  />
);

FillModeComponent.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onMouseDown: PropTypes.func.isRequired
};

export default FillModeComponent;
